/**
 * @module actions/customers
 */
import axios from 'axios'
import {
  API_URL,
  SET_CUSTOMERS,
  SET_ACTIVE_CUSTOMER
} from '../constants'

/**
 * @description Getting customers from API and dispatching event
 * @return {Promise} Axios promise
 */
export function getCustomers (id, activeCustomerId) {
  id = (typeof id !== 'undefined') ? id : 0
  let url = API_URL + '/Customer/Get?companyId=' + id
  return dispatch => {
    return axios.get(url).then((res) => {
      dispatch({
        type: SET_CUSTOMERS,
        customers: res.data
      })
      if (activeCustomerId) {
        dispatch(setActiveCustomer(activeCustomerId))
      }
      return res
    })
  }
}

/**
 * @description Dispatch event to set active customer
 * @return Action
 */
export function setActiveCustomer (customerId) {
  return {
    type: SET_ACTIVE_CUSTOMER,
    payload: customerId
  }
}

/**
 * @description Getting customers from API and dispatching event
 * @return {Promise} Axios promise
 */
export function getShopCustomers (shopId) {
  let url = API_URL + '/Customer/' + shopId
  return dispatch => {
    return axios.get(url).then((res) => {
      dispatch({
        type: SET_CUSTOMERS,
        customers: res.data
      })
      return res
    })
  }
}
/**
 * @description Getting customer from API
 * @return {Promise} Axios promise
 */
export function getCustomer (id) {
  let url = API_URL + '/Customer/Get/' + id
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Creating/saving a customer
 * @return {Promise} Axios promise
 */
export function CreateSaveCustomer (data) {
  let url = API_URL + '/Customer/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Validates CVR and PNumber if such already exists for specified Country
 * @return {Promise} Axios promise
 */
export function ValidateCVRAndPNumber (data) {
  let url = API_URL + '/Customer/ValidateCvrAndPNumber'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Updating customer settings
 * @return {Promise} Axios promise
 */
export function updateCustomerSettings (data) {
  let url = API_URL + '/Customer/Settings/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}
/**
 * @description Updating customer settings
 * @return {Promise} Axios promise
 */
export function getCustomerSettings (id) {
  let url = API_URL + '/Customer/Settings/Get/' + id
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Getting customer contact from API
 * @return {Promise} Axios promise
 */
export function getCustomerContact (id) {
  let url = API_URL + '/Contact/Get/' + id
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Getting customer contacts from API
 * @return {Promise} Axios promise
 */
export function getCustomerContacts (id) {
  let url = API_URL + '/Contact/' + id
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Creating/saving a customer contact
 * @return {Promise} Axios promise
 */
export function CreateSaveCustomerContact (data) {
  let url = API_URL + '/Contact/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Send password to contact
 * @return {Promise} Axios promise
 */
export function sendPassword (data) {
  let url = API_URL + '/Contact/SendLogin'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description get customer merge info
 * @return {Promise} Axios promise
 */
export function getCustomerMergeInfo (id) {
  let url = API_URL + '/Customer/GetCustomerMergeInfo/' + id
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description post customer merge info
 * @return {Promise} Axios promise
 */
export function PostCustomerMergeInfo (data) {
  let url = API_URL + '/Customer/PostCustomerMergeInfo/'
  return dispatch => {
    return axios.post(url, data)
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/customers.js